import { BaseFetch } from "../main-model"
export default class EducationTypeModel extends BaseFetch {
    getEducationTypeBy = (data) =>
    this.authFetch({
      url: "education-type/getEducationTypeBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getEducationTypeById = (data) =>
    this.authFetch({
      url: "education-type/getEducationTypeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateEducationTypeById = (data) =>
    this.authFetch({
      url: "education-type/updateEducationTypeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertEducationType = (data) =>
    this.authFetch({
      url: "education-type/insertEducationType",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteEducationTypeById = (data) =>
    this.authFetch({
      url: "education-type/deleteEducationTypeById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
